import { Helmet } from "react-helmet";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing231({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <Helmet>
        <script>
          {`
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-MWB3W3BL');
              `}
        </script>
      </Helmet>
      <div
        dangerouslySetInnerHTML={{
          __html: `
                <!-- Google Tag Manager (noscript) -->
                <noscript>
                  <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MWB3W3BL"
                  height="0" width="0" style="display:none;visibility:hidden"></iframe>
                </noscript>
                <!-- End Google Tag Manager (noscript) -->
              `,
        }}
      ></div>
      <RandingStyle4
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/231/1.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/231/3.png`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/231/2.gif`}
        formFieldColor="white"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        benefitInfoPosition="bottom"
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing231;
